import { BaseChildState } from '../../stateMachine/BaseChildState'
import GameSignals from '@/signals/GameSignals'
import { CascadeSpinData, SymbolData } from '@/modules'
import { SpecialSymbolType } from '@/containers/symbols/SpecialSymbolType'
import Facade from '@/Facade'

export class CascadeSpinState extends BaseChildState {
    public canTrigger(): boolean {
        return (
            this._model.spinData.winning_combinations &&
            this._model.spinData.winning_combinations[this._model.cascadeIndex].length > 0
        )
    }

    public begin() {
        GameSignals.completeCascadeSpin.connect(this.end)

        this._model.cascadeIndex++
        const slotGrid: SymbolData[][] = this._model.spinData.slot_grid[this._model.cascadeIndex]
        const cascadeReels: number[] = []
        const { winPositions } = this._model
        let scattersCount: number = 0
        let suspenseSpin: boolean

        winPositions.forEach((position: number[]) => {
            if (!cascadeReels.includes(position[0])) {
                cascadeReels.push(position[0])
            }
        })

        this._model.spinData.slot_grid[this._model.cascadeIndex - 1].forEach(
            (reel: SymbolData[], reelIndex: number) => {
                reel.forEach((symbol: SymbolData, symbolIndex: number) => {
                    if (
                        !winPositions.some((item) => item[0] === reelIndex && item[1] === symbolIndex) &&
                        symbol.id === SpecialSymbolType.SCATTER
                    ) {
                        scattersCount++
                    }
                })
            }
        )

        suspenseSpin = (this._model.roundState.isFreeSpins && scattersCount >= 2) || scattersCount >= 3

        if (Facade.isTurboSpin) {
            suspenseSpin = false
        }

        const data: CascadeSpinData = {
            winningCombination: this._model.spinData.winning_combinations[this._model.cascadeIndex],
            slotGrid,
            winPositions,
            suspenseSpin,
            cascadeReels,
        }

        GameSignals.cascadeSpin.emit(data)
    }

    public cleanUp() {
        GameSignals.completeCascadeSpin.disconnect(this.end)
    }
}
